import { injectGlobal } from "styled-components";
injectGlobal`
@import url('https://fonts.googleapis.com/css?family=Montserrat:100,400,500,600,700,800,900,bold');
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  outline: 0;
  font-family: 'Montserrat', sans-serif;
}

span{
  margin: 0 !important;
}

body, html {
  background: white;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
  height: 100%;
  width: 100%;
}

:root {
    --color-background: #FFFFFF;
    --color-primary: #FF7417;
    --color-primary-dark: #f26202;
    --color-success: #21ba45;
    --color-success-dark: #10aa30;
    --color-error: #dd0000;
    --color-error-dark: #bb0000;
    --color-secondary: #000;
    --color-title: rgba(0, 0, 0, 0.7);
    --color-text: #222;

    --border-radius: 4px;
    --medium-border-radius: 10px;
    --big-border-radius: 20px;
    --transition: .2s ease-in-out;

    --font-big-title-size: 2.5rem;
    --font-title-size: 1.5rem;
    --font-subtitle-size: 1rem;
    --font-text-size: 0.9rem;
    --font-description-size: 0.8rem;

    @media screen and (max-width: 600px) {
      --font-big-title-size: 2rem;
      --font-title-size: 1.2rem;
      --font-subtitle-size: 0.9rem;
      --font-text-size: 0.8rem;
      --font-description-size: 0.7rem;
    }
  }

`;
